export enum ChannelFeaturesEnum {
  first_flag = 'channel_feature.first_premium_feature',
  second_flag = 'channel_feature.second_premium_feature',
  cookie_opt_in = 'channel_feature.cookie_opt_in',
  enable_google_meet_breakouts = 'channel_feature.enable_google_meet_breakouts',
  sessions_v2 = 'channel_feature.sessions_v2',
  rsvp_integration = 'channel_feature.rsvp_sync_integration',
  dma_law = 'channel_feature.dma_law',
  event_publish_locking = 'channel_feature.event_publish_locking',
  google_meet_firesides = 'channel_feature.google_meet_firesides',
  ecdn_kollective = 'channel_feature.ecdn_kollective',
  ecdn_kollective_send_email = 'channel_feature.ecdn_kollective_send_email',
  video_archive = 'channel_feature.video_archive',
  use_mux = 'channel_feature.use_mux',
  courses = 'channel_feature.courses',
  high_volume_chat = 'channel_feature.high_volume_chat',
  public_chat_socket = 'channel_feature.public_chat_socket',
  platform_registration_field_limits = 'channel_feature.platform_registration_field_limits',
  mux_auto_transcripts = 'channel_feature.mux_auto_transcripts',
  mux_drm = 'channel_feature.mux_drm',
  ecdn_hive = 'channel_feature.ecdn_hive',
  ecdn_hive_send_email = 'channel_feature.ecdn_hive_send_email',
  ecdn_microsoft = 'channel_feature.ecdn_microsoft',
  webinarplus_launch = 'channel_feature.webinarplus_launch',
  brandtv_launch = 'channel_feature.brandtv_launch',
  allow_stream_without_recording = 'channel_feature.allow_stream_without_recording',
}
